import { LoaderCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function LoadingSpinner({ size = 'md' }) {
  const sizeClasses = {
    sm: 'size-4',
    md: 'size-8',
    lg: 'size-12',
  };
  
  return (
    <div className="flex items-center justify-center text-primary">
      <LoaderCircle className={cn('animate-spin', sizeClasses[size] || sizeClasses.md)} />
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="flex min-h-[320px] items-center justify-center">
      <div className="rounded-2xl border border-border/70 bg-card/70 p-6 shadow-sm backdrop-blur">
        <LoadingSpinner size="lg" />
      </div>
    </div>
  );
}
